var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.roles,"item-text":"title","item-value":"abbr","label":_vm.$lang('ROLE'),"clearable":""},model:{value:(_vm.role),callback:function ($$v) {_vm.role=$$v},expression:"role"}})
}
var staticRenderFns = []

export { render, staticRenderFns }